function tagDescontoPix() {
  const listHomeProds = wsMain?.globalData?.listHomeProds?.produtos;
  const listGroupProds = wsMain?.globalData?.listGroupProds?.grupos;
  const relatedProds = wsMain?.globalData?.listRelatedProds;
  const lastProds = wsMain?.globalData?.listLastProds;
  const listCategoryProds = wsMain?.globalData?.listCategoryProds?.produtos;
  const infoProduct = wsMain?.globalData?.infoProduto;
  const allProducts = [];

  if (infoProduct) {
    allProducts.push(infoProduct);
  }

  if (relatedProds && relatedProds.length > 0) {
    allProducts.push(...relatedProds);
  }

  if (lastProds && lastProds.length > 0) {
    allProducts.push(...lastProds);
  }

  if (listHomeProds && listHomeProds.length > 0) {
    listHomeProds.forEach((prod) => {
      allProducts.push(prod);
    });
  }

  if (listGroupProds && listGroupProds.length > 0) {
    listGroupProds.forEach((group) => {
      if (group.produtos && group.produtos.length > 0) {
        group.produtos.forEach((prod) => {
          allProducts.push(prod);
        });
      }
    });
  }

  if (listCategoryProds && listCategoryProds.length > 0) {
    listCategoryProds.forEach((prod) => {
      allProducts.push(prod);
    });
  }
  console.log(allProducts);
  if (!allProducts || allProducts.length === 0) {
    return;
  }

  if (infoProduct) {
    if (!infoProduct.precos?.desconto_avista) return;
    const tagDescontoPix = document.querySelector(".row .tagDescontoPix");

    if(tagDescontoPix.classList.contains('tagDescontoPixAlreadyApplied')) return

    if (tagDescontoPix) {
      tagDescontoPix.classList.add('tagDescontoPixAlreadyApplied')
      tagDescontoPix.innerHTML = `- ${infoProduct.precos.desconto_avista}% no PIX`;
    }
  }

  allProducts.forEach((prod) => {
    if (!prod.precos?.desconto_avista) return;
    const prodsElements = document.querySelectorAll(
      `[ws-prod-sku="${prod.codigo}"]`,
    );
    prodsElements.forEach((prodElement) => {
      const tagDescontoPix = prodElement.querySelector(".tagDescontoPix");
      if(tagDescontoPix.classList.contains('tagDescontoPixAlreadyApplied')) return

      tagDescontoPix.classList.add('tagDescontoPixAlreadyApplied')
      tagDescontoPix.innerHTML = `-${prod.precos.desconto_avista}% no PIX`;
    });
  });
}

function customBannerSize() {
  const banners = [
    document.querySelector("#banner-10"),
    document.querySelector("#banner-11"),
  ];

  const slides = [
    document.querySelector('[data-wsjs-id="prodSlide-6"] .keen-slider__slide'),
    document.querySelector('[data-wsjs-id="prodSlide-7"] .keen-slider__slide'),
  ];

  const titles = [
    document.querySelector('[data-wsjs-id="prodSlide-6"] .prod-list-titles'),
    document.querySelector('[data-wsjs-id="prodSlide-7"] .prod-list-titles'),
  ];

  const dots = [
    document.querySelector('[data-wsjs-id="prodSlide-6"] .dots'),
    document.querySelector('[data-wsjs-id="prodSlide-7"] .dots'),
  ];

  banners.forEach((bannerEl, index) => {
    const slideEl = slides[index];
    const titleEl = titles[index];
    const dotsEl = dots[index];

    if (!bannerEl || !slideEl || !titleEl || !dotsEl) return;

    bannerEl.style.height = `calc(${slideEl.offsetHeight}px - 2px)`;

    const bannerWidth = bannerEl.offsetWidth;

    titleEl.style.width = `calc(100% - ${bannerWidth}px - 20px)`;
    dotsEl.style.width = `calc(100% - ${bannerWidth}px - 20px)`;
  });
}
window.addEventListener("resize", customBannerSize);
try {
  isReady("product-list", () => {
    setTimeout(() => {
      customBannerSize();
    }, 500);
  });
} catch (error) {
  console.error(error);
}

try {
  isReady("product-list", tagDescontoPix);
  const listagem = document.querySelector(`#BodyListagem`);

  if (listagem) {
    window.addEventListener("scroll", () => {
      tagDescontoPix();
    });
  }
} catch (error) {}

try {
  isReady("pag-produto", tagDescontoPix);
} catch (error) {}

function customUnavaliable() {
  function createCustomUnavaliableModal() {
    const verify = document.querySelector(".custom-modal-unavaliable");

    if (verify) return;

    const modal = document.createElement("div");
    modal.classList.add("custom-modal-unavaliable");
    modal.innerHTML = `
    <div class="custom-modal-unavaliable__bg"></div>
        <div class="custom-modal-unavaliable__content">
         <div class="modal-unavaliable__content__close"><svg xmlns="http://www.w3.org/2000/svg" width="14.828" height="14.828" viewBox="0 0 14.828 14.828">
                      <path id="Caminho_8519" data-name="Caminho 8519" d="M978,2308l-12,12m0-12,12,12" transform="translate(-964.586 -2306.586)" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"></path>
                    </svg></div>
          <div class="custom-modal-unavaliable__content__title-container">
          
          </div>
          <div class="custom-modal-unavaliable__content__form-container">
            <div class="form__image-container">
            </div>
            <div class="form__form-container">
            <span class="titleModalUnavaliableOps">Ops!</span>
            <div class="titleModalUnavaliable">
              <h3>Nome do produto</h3>
                          
                    </div>
              <p>Mas não se preocupe! <br> Insira seu e-mail abaixo e assim que voltar em estoque, avisamos você.</p>
              <form
                data-wsjs-contact="container"
                onsubmit="return wsMain.modules['pag-contact'].sendContactForm()"
              >
                <fieldset class="contact-form-top">
                  <div data-wsjs-error-message="Preenchimento obrigat&oacute;rio.">
                    <input
                      id="nameform"
                      data-wsjs-contact="Nome"
                      type="text"
                      maxlength="50"
                      required
                      placeholder="Digite seu nome"
                    />
                  </div>
                  <div data-wsjs-error-message="Preenchimento obrigat&oacute;rio.">
                    <input
                      id="emailform"
                      data-wsjs-contact="E-mail"
                      type="email"
                      maxlength="50"
                      required
                      placeholder="Digite seu e-mail"
                    />
                  </div>
                </fieldset>
                <fieldset class="contact-form-bottom">
                  <input class="button-third" type="submit" value="Ativar notificação" />
                </fieldset>
              </form>
            </div>
          </div>
        </div>
    `;

    document.body.appendChild(modal);
  }

  function unavaliableBtn() {
    const allUnavaliableProds = document.querySelectorAll(
      ".prod-showcase-holder.unavaliable",
    );

    allUnavaliableProds.forEach((prod) => {
      if(prod.querySelector('.unavaliable-notify-wrapper')) return;
      const btn = document.createElement("div");
      btn.classList.add("unavaliable-notify-wrapper");
      btn.innerHTML = `
              <div class="unavaliable-notify-wrapper__btn">
                                            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="17" height="17" viewBox="0 0 17 17">
  <defs>
    <clipPath id="clip-path">
      <rect id="Retângulo_3312" data-name="Retângulo 3312" width="17" height="17" fill="#999"/>
    </clipPath>
  </defs>
  <g id="fi-rr-bell-ring" clip-path="url(#clip-path)">
    <path id="Caminho_10100" data-name="Caminho 10100" d="M14.776,10.859,12.1,15.219a3.708,3.708,0,0,1-2.741,1.755A3.764,3.764,0,0,1,8.918,17a3.692,3.692,0,0,1-2.125-.676,3.358,3.358,0,0,1-4.738-4.651l-.931-.93A3.729,3.729,0,0,1,1.8,4.934L5.885,2.408A6.275,6.275,0,0,1,13.2,2.8l1.175-1.175a.708.708,0,1,1,1,1L14.2,3.8a6.34,6.34,0,0,1,.573,7.06ZM5.714,15.333,3.08,12.7a1.927,1.927,0,0,0,.328,2.312,2,2,0,0,0,2.306.323Zm7.027-11.05a4.878,4.878,0,0,0-6.1-.671L2.546,6.138a2.313,2.313,0,0,0-.419,3.6L7.29,14.905A2.313,2.313,0,0,0,10.9,14.48l2.66-4.339a4.914,4.914,0,0,0-.816-5.862ZM13.647,17a.708.708,0,0,1-.419-1.281,6.115,6.115,0,0,0,2.348-3.83.708.708,0,1,1,1.383.3,7.579,7.579,0,0,1-2.9,4.67A.709.709,0,0,1,13.647,17ZM.71,4.065A.708.708,0,0,1,.143,2.936,7.574,7.574,0,0,1,4.9.014.708.708,0,0,1,5.181,1.4,6.117,6.117,0,0,0,1.276,3.778a.708.708,0,0,1-.567.287Z" transform="translate(-0.001 0)" fill="#999"/>
  </g>
</svg>
                  <p>Avise-me</p>
              </div>
              `;

      btn.addEventListener("click", openModal);

      prod.appendChild(btn);
    });

    const pagProdUnavaliableBtn = document.querySelector(
      ".unavaliable-notify-wrapper__btn",
    );

    if (!pagProdUnavaliableBtn) return;

    pagProdUnavaliableBtn.addEventListener("click", (e) => {
      openModal(false, wsMain?.globalData?.infoProduto);
    });
  }

  function openModal(event, customData) {
    const modal = document.querySelector(".custom-modal-unavaliable");
    modal.classList.add("active-custom-modal-unavaliable");
    modal.classList.remove("custom-modal-unavaliable-hidding");

    let prodHolder;

    if (event) {
      prodHolder = findProdShowcaseHolder(event);
    }

    if (!prodHolder && !customData) return;

    console.log("customData: ", customData);
    let img;

    if (prodHolder) {
      img = prodHolder.querySelector(".prod-showcase-image img");
    }

    const imgContainer = modal.querySelector(".form__image-container");

    if (img) {
      const cloneImg = img.cloneNode(true);
      imgContainer.innerHTML = "";

      imgContainer.appendChild(cloneImg);
    }

    if (
      customData?.fotos &&
      Array.isArray(customData?.fotos) &&
      customData?.fotos.length
    ) {
      const [foto] = customData?.fotos;

      if (foto) {
        const imgElm = document.createElement("img");
        imgElm.alt = "Imagem do produto";
        imgElm.src = foto.normal;
        imgContainer.appendChild(imgElm);
      }
    }

    let name;

    if (prodHolder) {
      name = prodHolder.querySelector(
        ".prod-showcase-info .prod-showcase-info-name p",
      ).textContent;
    }

    if (customData) {
      name = customData.nome;
    }

    const nameContainer = modal.querySelector(".form__form-container h3");

    nameContainer.innerHTML = `O item ${name} está em falta, neste momento.`;
  }

  function findProdShowcaseHolder(event) {
    let currentElement = event.target;
    let depth = 0;

    while (currentElement && depth < 30) {
      if (
        currentElement.classList &&
        currentElement.classList.contains("prod-showcase-holder")
      ) {
        return currentElement;
      }
      currentElement = currentElement.parentNode;
      depth++;
    }

    return false;
  }

  function handleCloseModal() {
    const closeBtn = document.querySelector(
      ".modal-unavaliable__content__close",
    );
    closeBtn.addEventListener("click", () => {
      const modal = document.querySelector(".custom-modal-unavaliable");
      modal.classList.add("custom-modal-unavaliable-hidding");
      setTimeout(() => {
        modal.classList.remove("active-custom-modal-unavaliable");
      }, 400);
    });
  }

  createCustomUnavaliableModal();
  unavaliableBtn();
  handleCloseModal();

  const listagem = document.querySelector(`#BodyListagem`);

  if (listagem) {
    window.addEventListener("scroll", () => {
      unavaliableBtn();
    });
  }
}

function stepper(btn) {
  let inpt = btn.parentNode.parentNode.querySelector("input");

  btn.getAttribute("button-stepper") == "increment"
    ? inpt.stepUp()
    : inpt.stepDown();
}

try {
  isReady("product-list", customUnavaliable);
} catch (error) {}
